/**
 * Talewave search config - copied from oceread
 */
import { searchCommonConfig } from './common'

export const searchConfig = {
  ...searchCommonConfig,
}
